import Vue from "vue";
import VueRouter from "vue-router";
import { currentUser, pendingUser, logout } from "@/lib/utils";

import guest from "./guest";
import dashboard from "./dashboard";
import verify from "./verify-identity";
import authx from "./authx";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = guest.concat(dashboard, verify, authx);

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser() && !pendingUser()) {
    next("/login");
    logout();
  } else if (requiresAuth && pendingUser()) {
    next("/update-password");
  } else {
    next();
  }
});

export default router;
